import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { HiOutlineTrash } from 'react-icons/hi'
import _ from "lodash"
export default function TagsBasicInfoComponent({selectedTag,handleFormKeywordItemChange,tagValues, handleInnerFormChange, selectTagSettings }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',
                )
              }}
              type="text"
              value={selectedTag?.Name}
            />
          </div>
        }
        expandedPanel="tagInfo"
        headerTitle="Basic Info"
      />
 <AccordionContainer
        child={
          <div className="h-[500px] overflow-auto w-full bg-white p-4">
          <table className="w-full text-xs bg-red-50">
            <thead className="w-full border-y border-black border-opacity-20">
              <tr className="w-full text-left h-12">
              <th className="border-r-2  last:border-r-0 w-auto px-10">Index</th>
                <th className="border-r-2  last:border-r-0 w-auto px-10">Value</th>
                <th className="border-r-2  last:border-r-0 w-auto px-10">Action</th>
              </tr>
            </thead>
            <tbody className="w-full bg-red-400 h-[400px]">
              {_.map(tagValues,(cardValue: any, index: any) => (
                <tr key={index} className="w-full cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                 <td  className="px-6 py-4  w-auto">{index+1}</td>
                    <td 
                    className="px-6 py-4  w-auto">
                     <InputContainer
        
        name="Value"
        onValueChange={(event: any) => {
          handleFormKeywordItemChange({
            value: event.target.value,
            field: 'Value',
            idx: index
          });
        } }
        type="text"
        value={cardValue.Value} />             
                    </td>
                  <td key={9} className="flex px-5 w-max flex-row justify-start item-baseline cursor-pointer pt-6 space-x-2">
                          <button className="text-red-500 hover:text-red-700" >
                            <HiOutlineTrash className="w-6 h-6" />
                          </button>
                        </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
}
        expandedPanel="tagInfo"
        headerTitle="Basic Info"
      />
    
    </>
  )
}